import j, { forwardRef as L } from "react";
import { cls as T } from "../../../helpers/cls.js";
var h = Object.defineProperty,
  N = Object.defineProperties,
  D = Object.getOwnPropertyDescriptors,
  o = Object.getOwnPropertySymbols,
  u = Object.prototype.hasOwnProperty,
  c = Object.prototype.propertyIsEnumerable,
  f = (e, r, a) => r in e ? h(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : e[r] = a,
  t = (e, r) => {
    for (var a in r || (r = {})) u.call(r, a) && f(e, a, r[a]);
    if (o) for (var a of o(r)) c.call(r, a) && f(e, a, r[a]);
    return e;
  },
  E = (e, r) => N(e, D(r)),
  z = (e, r) => {
    var a = {};
    for (var i in e) u.call(e, i) && r.indexOf(i) < 0 && (a[i] = e[i]);
    if (e != null && o) for (var i of o(e)) r.indexOf(i) < 0 && c.call(e, i) && (a[i] = e[i]);
    return a;
  };
const m = L((e, r) => {
  var a = e,
    {
      id: i,
      type: s,
      typePassword: y,
      ariaLabel: d,
      state: n,
      errorId: v,
      hasLimitText: l,
      limitTextID: x,
      disabled: p,
      size: O,
      className: w,
      label: I
    } = a,
    _ = z(a, ["id", "type", "typePassword", "ariaLabel", "state", "errorId", "hasLimitText", "limitTextID", "disabled", "size", "className", "label"]);
  const P = g => {
    const b = g.target;
    b.value = b.value.slice(0, l);
  };
  return j.createElement("input", t(t(E(t(t(t(t({
    id: i,
    type: s !== "password" ? s : y
  }, d && !I && {
    "aria-label": d
  }), n === "loading" && {
    "aria-busy": !0
  }), n === "error" && {
    "aria-invalid": !0,
    "aria-describedby": v
  }), l && {
    "aria-describedby": x,
    maxLength: l
  }), {
    disabled: p,
    className: T({
      "olx-text-input__input-field": !0,
      "olx-text-input__input-field--medium": O === "medium",
      "olx-text-input__input-field--disabled": p
    }, w),
    ref: r
  }), l && {
    onInput: P
  }), _));
});
m.displayName = "Input";
export { m as Input };